import React from "react";
import { useTranslation } from "react-i18next";

import { useRetrieveProjectsElementsTags } from "@planzone/view-models";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function sanitize(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function Form(props: Props) {
  const { t } = useTranslation();
  const [formData, setFormData] = React.useState("");
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    tags,
    retrieveProjectsElementsTags,
  } = useRetrieveProjectsElementsTags();
  const unUsedTags = tags.filter(
    (tag) => !props.tags.find(({ name }) => tag.name === name),
  );
  const filteredTags = unUsedTags.filter((tag) =>
    new RegExp(sanitize(formData), "i").test(tag.name),
  );

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectsElementsTags({});
  }, []);

  return (
    <div className={styles.form}>
      <form
        className={styles.main}
        onSubmit={(e) => {
          e.preventDefault();
          props.add({ name: formData });
        }}
      >
        <input
          type="text"
          className={styles.input}
          placeholder={t("listsList.tags.placeholder")}
          value={formData}
          onChange={({ target }) => setFormData(target.value)}
        />
        <Button
          className={styles.button}
          type="submit"
          isDisabled={formData.trim() === ""}
        >
          {t("listsList.tags.submit")}
        </Button>
      </form>
      {unUsedTags.length > 0 && (
        <ul className={styles.list}>
          {filteredTags.map((tag) => (
            <li
              key={tag.name}
              className={styles.item}
              onClick={() => props.add(tag)}
            >
              {tag.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export { Form };
